import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../features/schedule/redux/actions';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import ParentContentCard from '../common/ParentContentCard';
import CustomLoader from '../common/CustomLoader';
import ShowTaskDetail from './ShowTaskDetail';

export class TaskDetail extends Component {
  static propTypes = {
    schedule: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  componentDidMount() {
    const { actions, match } = this.props;
    const { taskId, projectId, version } = match.params;
    actions.loadTaskDetail({ projectId, taskId, version });
  }

  showTaskDetail = () => {
    const { schedule } = this.props;
    const { taskDetail } = schedule;
    if (taskDetail) {
      return <ShowTaskDetail taskDetail={taskDetail} />;
    }
  };

  render() {
    const { schedule } = this.props;
    const { loadTaskDetailPending } = schedule;
    return (
      <CommonPageComponent>
        <ParentContentCard icon="alarm" title="Background Task Detail">
          {loadTaskDetailPending ? (
            <div className="text-center">
              <CustomLoader loading={loadTaskDetailPending} size="20px" color="#303453" />
            </div>
          ) : (
            <>{this.showTaskDetail()}</>
          )}
        </ParentContentCard>
      </CommonPageComponent>
    );
  }
}
function mapStateToProps(state) {
  return {
    schedule: state.schedule,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(TaskDetail);
